import type { FlaggedKeyword } from "@verity/database/prisma";
import { useState, useEffect } from "react";
import type { VerityApi } from "../api/fetch";

export const useInstituteKeywords = (
	getInstituteSettings?: VerityApi["getInstituteSettings"],
	instituteUuid?: string,
) => {
	const [instituteKeywords, setInstituteKeywords] = useState<FlaggedKeyword[]>([]);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		void (async () => {
			try {
				setLoading(true);
				if (!instituteUuid || !getInstituteSettings) {
					setInstituteKeywords([]);
					return;
				}
				const settings = await getInstituteSettings(instituteUuid);
				setInstituteKeywords(settings.flaggedKeywords ?? []);
			} catch (error) {
				console.error("Failed to fetch institute keywords:", error);
				setInstituteKeywords([]);
			} finally {
				setLoading(false);
			}
		})();
	}, [getInstituteSettings, instituteUuid]);

	return { instituteKeywords, loading };
};
